// extracted by mini-css-extract-plugin
module.exports = {"shirtPrompt":"ShirtPrompt_shirtPrompt__LXHP5","shirtPrompt__exit":"ShirtPrompt_shirtPrompt__exit__RkGdO"};